import {INPUT_TYPES} from "../constants/inputs";
import Button from "../ui/button";


export default class MobileInputProvider extends EventTarget {
    static preload(scene){
        scene.load.image('gamepad_button_up', 'src/assets/gamepad/btn_up.png');
        scene.load.image('gamepad_button_up_pressed', 'src/assets/gamepad/btn_up.png');

        scene.load.image('gamepad_button_down', 'src/assets/gamepad/btn_down.png');
        scene.load.image('gamepad_button_down_pressed', 'src/assets/gamepad/btn_down.png');

        scene.load.image('gamepad_button_left', 'src/assets/gamepad/btn_left.png');
        scene.load.image('gamepad_button_left_pressed', 'src/assets/gamepad/btn_left.png');

        scene.load.image('gamepad_button_right', 'src/assets/gamepad/btn_right.png');
        scene.load.image('gamepad_button_right_pressed', 'src/assets/gamepad/btn_right.png');
    }

    constructor(scene) {
        super();
        this.scene = scene;
        this.game = scene.game;

        this.buttonUp = new Button({
            scene: this.scene,
            img: 'gamepad_button_up',
            imgPressed: 'gamepad_button_up_pressed',
            x: this.game.config.width - 100,
            y: this.game.config.height - 270,
            scaleX: 0.4,
            scaleY: 0.4
        })
        this.buttonUp.onClick = () => {
            this.inputs[INPUT_TYPES.JUMP] = true;
        }
        this.buttonUp.onDown = () => {
            this.inputs[INPUT_TYPES.JUMP] = true;
        }

        this.buttonDown = new Button({
            scene: this.scene,
            img: 'gamepad_button_down',
            imgPressed: 'gamepad_button_down_pressed',
            x: this.game.config.width - 100,
            y: this.game.config.height - 100,
            scaleX: 0.4,
            scaleY: 0.4
        })
        this.buttonDown.onClick = () => {
            this.inputs[INPUT_TYPES.JUMP] = true;
        }
        this.buttonDown.onDown = () => {
            this.inputs[INPUT_TYPES.JUMP] = true;
        }

        this.buttonRight = new Button({
            scene: this.scene,
            img: 'gamepad_button_right',
            imgPressed: 'gamepad_button_right_pressed',
            x: 280,
            y: this.game.config.height - 150,
            scaleX: 0.4,
            scaleY: 0.4
        })
        this.buttonRight.onClick = () => {
            this.inputs[INPUT_TYPES.RIGHT] = true;
        }
        this.buttonRight.onDown = () => {
            this.inputs[INPUT_TYPES.RIGHT] = true;
        }

        this.buttonLeft = new Button({
            scene: this.scene,
            img: 'gamepad_button_left',
            imgPressed: 'gamepad_button_left_pressed',
            x: 100,
            y: this.game.config.height - 150,
            scaleX: 0.4,
            scaleY :0.4
        })
        this.buttonLeft.onClick = () => {
            this.inputs[INPUT_TYPES.LEFT] = true;
        }
        this.buttonLeft.onDown = () => {
            this.inputs[INPUT_TYPES.LEFT] = true;
        }
        this.defaultInputState();
        this.show();


        this.buttonUp.onUp = () => {
            const event = new CustomEvent("keyup", {detail: INPUT_TYPES.UP});
            this.dispatchEvent(event);
        }

        this.buttonDown.onUp = () => {
            const event = new CustomEvent("keyup", {detail: INPUT_TYPES.DOWN});
            this.dispatchEvent(event);
        }

        this.buttonLeft.onUp = () => {
            const event = new CustomEvent("keyup", {detail: INPUT_TYPES.LEFT});
            this.dispatchEvent(event);
        }

        this.buttonRight.onUp = () => {
            const event = new CustomEvent("keyup", {detail: INPUT_TYPES.RIGHT});
            this.dispatchEvent(event);
        }
    }

    show(){
        this.buttonRight.show();
        this.buttonLeft.show();
        this.buttonUp.show();
    }

    hide(){
        this.buttonRight.hide();
        this.buttonLeft.hide();
        this.buttonUp.hide();
    }

    defaultInputState(){
        this.inputs = {
            [INPUT_TYPES.LEFT]: false,
            [INPUT_TYPES.RIGHT]: false,
            [INPUT_TYPES.JUMP]: false
        }
    }

    getState(){
        this.inputs[INPUT_TYPES.JUMP] = this.buttonUp.pressed;
        this.inputs[INPUT_TYPES.LEFT] = this.buttonLeft.pressed;
        this.inputs[INPUT_TYPES.RIGHT] = this.buttonRight.pressed;
        const state = JSON.parse(JSON.stringify(this.inputs));
        this.defaultInputState();
        return state;
    }
}